module.exports = __webpack_public_path__ + "static/media/CTLA_3-540w.382568c0.webp";